export default "__VITE_ASSET__$A1OSPB5__"